import React from "react";
import { Navigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useAdminAuth } from "@/state/AdminAuthContext";

export function AdminProtectedRoute({ children }) {
  const { status } = useAdminAuth();

  if (status === "checking") {
    return (
      <div
        className="min-h-screen grid place-items-center bg-[#0b1f18]"
        data-testid="admin-auth-loading"
      >
        <Loader2 className="h-6 w-6 animate-spin text-[#c79a3b]" strokeWidth={2} />
      </div>
    );
  }

  if (status !== "authenticated") {
    return <Navigate to="/admin/login" replace />;
  }

  return children;
}
